import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/Login3')));
const AuthRegister = Loadable(lazy(() => import('views/pages/authentication/Register3')));
const AuthForgotPassword = Loadable(lazy(() => import('views/pages/authentication/ForgotPassword3')));
const ChangePassword = Loadable(lazy(() => import('views/pages/authentication/ChangePassword')));
const PasswordConfigured = Loadable(lazy(() => import('views/pages/authentication/PasswordConfigured')));
const RecoverPassword = Loadable(lazy(() => import('views/pages/authentication/RecoverPassword')));
const SetUpMFA = Loadable(lazy(() => import('views/pages/authentication/SetUpMFA')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/',
            element: <AuthLogin />
        },
        {
            path: '/login',
            element: <AuthLogin />
        },
        { path: 'setupmfa', element: <SetUpMFA />, index: true },
        {
            path: '/register',
            element: <AuthRegister />
        },
        {
            path: '/forgot',
            element: <AuthForgotPassword />
        },
        {
            path: 'recover',
            element: <RecoverPassword />,
            index: true
        },
        {
            path: 'change',
            element: <ChangePassword />,
            index: true
        },
        {
            path: 'configured',
            element: <PasswordConfigured />,
            index: true
        }
    ]
};

export default LoginRoutes;
